//export const BASE_URL =
  // process.env.NODE_ENV === 'production'
    // ? 'http://localhost:10000'
    // : ""; // if using proxy

 // export const BASE_URL =
  // process.env.NODE_ENV === 'development' ? 'http://localhost:10000' : '';

export const BASE_URL = ''; // If using proxy
 
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
export const HOUSES_URL = '/api/houses';
export const EXPENSES_URL = '/api/expenses';
export const INCOMES_URL = '/api/incomes';
export const NOTES_URL = '/api/notes';
export const STAFFNOTES_URL = '/api/notes';
export const CUSTOMERS_URL = '/api/customers';
export const SALES_URL = "/api/sales";
export const SUPPLIES_URL = "/api/supplies";
export const SUPPLIERS_URL = '/api/suppliers';
export const PURCHASES_URL = "/api/sales";
export const TRANSFERS_URL = "/api/transfers";
export const STOCKS_URL = "/api/stocks";
export const DEPOSITS_URL = "/api/deposits";
export const BAGS_URL = "/api/bags";
export const OPENINGSTOCKS_URL = "/api/openingstocks";



